import Layout from "components/Layout";
import ChangeLogDataTable from "./component/ChangeLogDataTable";

function Changes() {
  return (
    <Layout title="변경 이력">
      <ChangeLogDataTable />
    </Layout>
  );
}

export default Changes;